<template>
    <div class="col-lg-6 mb-4">
        <div class="box">
            <div class="box-offset">
                <div class="box-ttl-wrap">
                    <div class="box-ttl">Shift Board<span class="box-ttl-number-box">{{listOfShift.length}}</span></div>
                    <div
                        class="btn btn--outline-primary btn--small"
                        @click="createNewShift"
                    >+ Add</div>
                </div>
                <div class="table-holder table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th>Location</th>
                            <th >Priority</th>
                            <th class="text-right">View</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr
                            v-for="shift in listOfShift"
                            :key="shift.id"
                        >
                            <td>
                                <div>
                                    <div class="color--dark-text">
                                        <p><b>{{shift.client.name}}</b></p>
                                    </div>
                                </div>
                            </td>
                            <td>
                                {{ shift.priority | capitalizeFirst }}
                            </td>
                            <td class="text-right">
                                <a href="javascript:void(0)"
                                   class="color--secondary"
                                   @click="showCustomModal('info',`shift`+shift.id)">
                                    <i class="fas fa-eye"></i>
                                </a>
                                <EmployeeShiftModal
                                    :title="`Shift Board Information`"
                                    :modal-id="getCustomModalId('info',`shift`+shift.id)"
                                    :shift="shift"
                                    :isActionModal="false"
                                >
                                </EmployeeShiftModal>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="text-center">
                    <a href="/master-admin/shift-board" class="link">View All</a>
                </div>

            </div>
        </div>
    </div>
</template>

<script>


import DashboardService from "./DashboardService";
import DateConverter from "../../../../../resources/js/mixins/DateConverter";
import ModalHandler from "../../../../../resources/js/mixins/ModalHandler";
import EmployeeShiftModal from "../../../../../resources/js/components/EmployeeShiftModal.vue";

export  default {
    name: "ShiftsBoard",
    components: {EmployeeShiftModal},
    mixins: [DateConverter, ModalHandler],
    data() {
        return {
            listOfShift: [],
            filters: {
                day: this.getDayOfWeek().toLowerCase(),
            }
        }
    },
    methods: {
        createNewShift() {
            window.location.href = '/master-admin/shift-board/create'
        },
        async getListOfShifts() {
            try {
                const {data: response} = await DashboardService.getShiftsInfo(this.filters)
                this.listOfShift = response
            } catch (error) {
                this.$handleErrors(error)
            }
        }
    },
    mounted() {
        this.getListOfShifts()
    }
}

</script>



<style scoped>

</style>
